import type { PersonalDataFromFormik } from './types';
import type { PersonalDataToBackend } from 'app/api/services/client/client-profile/types';

import { ResponseStatus } from 'app/api';
import { tFunction } from 'app/lang';

import dictionary from './PersonalDataModal.dictionary.json';

type FormikDataKeys = keyof PersonalDataFromFormik;
type ValidatedData = Record<FormikDataKeys, string>;

export const personalDataValidation  = (t: tFunction) => {
  return (values: PersonalDataFromFormik): ValidatedData => {
    const errors = {} as ValidatedData;
    const validationValues = Object.keys(values) as FormikDataKeys[];

    validationValues.forEach((key) => {
      if (key === 'middleName') {
        return;
      }
      if (!values[key]?.trim().length) {
        errors[key] = t(dictionary.emptyField);
      }
    });

    return errors;
  };
};

export function preparePersonalDataToBackend(data: PersonalDataFromFormik): PersonalDataToBackend {
  return {
    lastName: data.lastName.trim(),
    firstName: data.firstName.trim(),
    middleName: data.middleName.trim(),
  };
}
export type ErrorMessageKey = keyof typeof getPersonalDataErrorMessage;

export const getPersonalDataErrorMessage = (t: tFunction) => ({
  [ResponseStatus.UNPROCESSABLE_ENTITY]: t(dictionary.unprocessableEntity),
  [ResponseStatus.INTERNAL_SERVER]: t(dictionary.internalServer),
});
